import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from "../imgs/Logo.png"

const MenuBar: React.FC = () => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [eventsOpen, setEventsOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (location.pathname === '/') {
      setIsScrolled(false);
      return;
    }

    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  const getTextColor = () => {
    if (mobileMenuOpen) {
      return 'text-greenbutton';
    }
    return location.pathname === '/' ? 'text-greentext' : 'text-greenbutton';
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-30 transition-all duration-300 ${
        isScrolled ? 'bg-tantext shadow-lg' : 'bg-transparent'
      } ${getTextColor()} h-24 md:h-auto`}
      style={{
        backgroundColor: mobileMenuOpen ? '#dfd9d0' : undefined,
        boxShadow: mobileMenuOpen ? '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)' : undefined
      }}
    >
        <div className="md:hidden flex items-center justify-between" style={{ paddingLeft: '10px', paddingTop: '30px', paddingRight: '0px', height: '80px' }}>
        <Link to="/" className='flex items-center' style={{ marginLeft: '-60px', marginTop: '0px' }}>
          <img
            src={Logo}
            alt="Motiv8 Logo"
            className="h-48 object-cover"
            style={{ objectPosition: 'center center' }}
          />
          <div style={{ marginLeft: '-55px', marginTop: '-15px' }}>
            <span className="text-4xl font-bold">
              Motiv8 Living
            </span>
          </div>
        </Link>
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="text-5xl flex items-center"
          style={{ marginTop: '-20px', marginRight: '10px'}}
        >
          ☰
        </button>
      </div>

      <div className="hidden md:block absolute top-0 left-0 mt-[-64px] ml-[-64px] flex items-center">
        <Link to="/" className='flex items-center'>
          <img
            src={Logo}
            alt="Motiv8 Logo"
            className="h-72 object-contain"
          />
          <span className="text-4xl font-bold -mt-8 -ml-16">
            Motiv8 Living
          </span>
        </Link>
      </div>

      <div className="py-7 sm:px-6 lg:px-8">
        <div className="flex items-center justify-end h-16 font-sans">
          <div className="hidden md:flex space-x-16 text-xl relative">
            <div
              className="relative"
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <Link to="/services" className="cursor-pointer px-4 py-2 hover:opacity-80">
                Services
              </Link>
              {servicesOpen && (
                <div className="absolute left-1/2 transform -translate-x-1/2 mt-0 bg-tantext text-darkgreentext rounded shadow-lg w-64 border border-gray-300">
                  <ul className="flex flex-col items-center text-base">
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/group-breathwork">Group Breathwork Classes - Online</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/individual-instruction">Individual 1:1 Instruction</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/wim-hof-workshop">Wim Hof Fundamentals Workshop</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/community-breathwork">Community Breathwork</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/breathwork-and-brunch">Breathwork and Brunch</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/travel-retreats">Travel Retreats</Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            <div
              className="relative"
              onMouseEnter={() => setEventsOpen(true)}
              onMouseLeave={() => setEventsOpen(false)}
            >
              <span className="cursor-pointer px-4 py-2 hover:opacity-80">Events</span>
              {eventsOpen && (
                <div className="absolute left-1/2 transform -translate-x-1/2 mt-0 bg-tantext text-darkgreentext rounded shadow-lg w-64 border border-gray-300">
                  <ul className="flex flex-col items-center text-base">
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/private-events">Private Events</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <a href="https://calendly.com/seanmotiv8living" className="hover:opacity-80">
                        Upcoming Events
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            <Link to="/philosophy" className="hover:opacity-80">
              Philosophy
            </Link>
            <Link to="/about" className="hover:opacity-80">
              About
            </Link>
            <Link to="/contact" className="hover:opacity-80">
              Contact
            </Link>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-tantext shadow-lg absolute top-24 left-0 w-full">
          <div className="px-4 py-2 space-y-4">
            <div>
              <button
                onClick={() => setServicesOpen(!servicesOpen)}
                className="flex items-center justify-between w-full text-left py-2 font-semibold"
              >
                Services
                <span className="text-lg">{servicesOpen ? '−' : '+'}</span>
              </button>
              {servicesOpen && (
                <div className="pl-4 space-y-2 py-2">
                  <Link to="/group-breathwork" className="block py-1" onClick={closeMobileMenu}>Group Breathwork Classes - Online</Link>
                  <Link to="/individual-instruction" className="block py-1" onClick={closeMobileMenu}>Individual 1:1 Instruction</Link>
                  <Link to="/wim-hof-workshop" className="block py-1" onClick={closeMobileMenu}>Wim Hof Fundamentals Workshop</Link>
                  <Link to="/community-breathwork" className="block py-1" onClick={closeMobileMenu}>Community Breathwork</Link>
                  <Link to="/breathwork-and-brunch" className="block py-1" onClick={closeMobileMenu}>Breathwork and Brunch</Link>
                  <Link to="/travel-retreats" className="block py-1" onClick={closeMobileMenu}>Travel Retreats</Link>
                </div>
              )}
            </div>
            
            <div>
              <button
                onClick={() => setEventsOpen(!eventsOpen)}
                className="flex items-center justify-between w-full text-left py-2 font-semibold"
              >
                Events
                <span className="text-lg">{eventsOpen ? '−' : '+'}</span>
              </button>
              {eventsOpen && (
                <div className="pl-4 space-y-2 py-2">
                  <Link to="/private-events" className="block py-1" onClick={closeMobileMenu}>Private Events</Link>
                  <a href="https://calendly.com/seanmotiv8living" className="block py-1" onClick={closeMobileMenu}>Upcoming Events</a>
                </div>
              )}
            </div>
            
            <Link to="/philosophy" className="block py-2 font-semibold" onClick={closeMobileMenu}>Philosophy</Link>
            <Link to="/about" className="block py-2 font-semibold" onClick={closeMobileMenu}>About</Link>
            <Link to="/contact" className="block py-2 font-semibold" onClick={closeMobileMenu}>Contact</Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default MenuBar;
